module.exports = __webpack_public_path__ + "static/media/bs-teams.f795b30d.mp4";